import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ReProvisionalComponent } from '../re-provisional/re-provisional.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ReassignTeachersComponent } from '../reassign-teachers/reassign-teachers.component';
import { ReassignFinalComponent } from '../reassign-final/reassign-final.component';
import { SendEmailDialogComponent } from '../send-email-dialog/send-email-dialog.component';

@Component({
  selector: 'app-assign-teacher',
  templateUrl: './assign-teacher.component.html',
  styleUrls: ['./assign-teacher.component.scss']
})
export class AssignTeacherComponent implements OnInit {
  teacherAssignForm: FormGroup;
  internalTeachersArray: FormArray;
  externalTeachersArray: FormArray;
  COTeachersArray: FormArray;
  CITeachersArray: FormArray;
  INVTeachersArray: FormArray;
  intExternalTeaArray: FormArray;
  collegeList: any;
  filteredCollegeList: any;
  dialogRef: MatDialogRef<any>;
  subjectList: any;
  filteredsubjectList: any;
  CourseList: any;
  filteredListCourse: any;
  teachersList: any;
  filteredteachersList: any;
  savedTeachers: any;
  InterTeach: boolean = false;
  ExterTeach: boolean = false;
  ExterTeachCnt: any;
  InterTeachCnt: any;
  internalError: string;
  externalError: string;
  internalSelected: any;
  externalSelected: any;
  selectedCount: any;
  sessionList: any[];
  SessionFilterList: any[];
  ExamId: any;
  savedTeachersData: any;
  APIService: string;
  requestTypeList
  filteredrequestTypeList
  PETeacher = false;
  COTeacher = false;
  CITeacher = false;
  INVTeacher = false;
  publishBtn = true;
  publishMessage: any;
  disableAcceptAll: boolean = false;
  publishDone: boolean = false;
  disableSendNotifications: boolean = false;

  isFinalListMode: boolean = false;

  constructor(public fb: FormBuilder,
    public umsService: UmsService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private dialogRef2: MatDialogRef<AssignTeacherComponent>,
    private httpClient: HttpClient,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.teacherAssignForm = this.fb.group({
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
      SubCode: new FormControl(''),
      SessionId: new FormControl(''),
      CollegeDistrict: new FormControl(''),
      ReqType: new FormControl(''),
      Notes: new FormControl(''),
      count: new FormControl(''),
      internalTeachersArray: this.fb.array([]),
      externalTeachersArray: this.fb.array([]),
      COTeachersArray: this.fb.array([]),
      CITeachersArray: this.fb.array([]),
      INVTeachersArray: this.fb.array([]),
      intExternalTeaArray: this.fb.array([]),
    });
    this.getCollege();
    this.getCourse();
    this.fetchSession();
    this.fetchRequestType();
  }

  // fetchRequestType() {
  //   this.spinner.show();
  //   const payload = {};
  //   payload['CdType'] = 'ReqTy';
  //   this.umsService.getCodeType(payload).subscribe((res) => {
  //     this.spinner.hide();
  //     if (res.status) {
  //       this.requestTypeList = res.data;
  //       this.filteredrequestTypeList = this.requestTypeList.slice();
  //     } else {
  //       this.requestTypeList = [];
  //       this.filteredrequestTypeList = this.requestTypeList.slice();
  //     }
  //   },
  //     (ERROR: HttpErrorResponse) => {
  //       this.spinner.hide();

  //     })
  // }
  fetchRequestType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ReqTy';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.requestTypeList = (res.data || []).filter(
          (item) => item.CdCode?.toUpperCase() === 'PE'
        );
        this.filteredrequestTypeList = this.requestTypeList.slice();

        if (this.requestTypeList.length > 0) {
          this.teacherAssignForm.patchValue({ ReqType: 'PE' });
        } else {
          this.requestTypeList = [];
          this.filteredrequestTypeList = [];
          this.teacherAssignForm.patchValue({ ReqType: '' });
        }
      } else {
        this.requestTypeList = [];
        this.filteredrequestTypeList = [];
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }
  getCollege() {
    let payload = {}
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  getsubjects(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.getCoursewiseSub(payload).subscribe(res => {
      this.spinner.hide()
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
    });
  }


  getCourse() {
    this.spinner.show();
    const payload = {};
    // this.table = false;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getCount(item) {
    this.ExterTeachCnt = item.ExternalCount;
    this.InterTeachCnt = item.InternalCount;
    this.ExamId = item.EmId;
    this.publishDone = false;
    this.disableAcceptAll = false;
    this.disableSendNotifications = false;
    this.isFinalListMode = false;
    this.getTeachersData();
  }

  mapAssignedForToTechDesig(assignedFor: string): string {
    if (!assignedFor) return null;
    const lower = assignedFor.toLowerCase().trim();
    if (lower.includes('chairman') || lower.includes('convener')) return 'CP';
    if (lower === 'internal' || lower.includes('internal examiner')) return 'INT';
    if (lower === 'external' || lower.includes('external examiner')) return 'EXT';
    console.warn('Unknown AssignedFor value:', assignedFor);
    return null;
  }
  private rebuildIntExternalFormArray() {
    const intExternalTeaArray = this.teacherAssignForm.get('intExternalTeaArray') as FormArray;
    intExternalTeaArray.clear();

    this.teachersList.forEach(teacher => {
      const saved = this.savedTeachersData?.find(t => {
        return t.InternalTechId === teacher.IETechId || t.ExternalTechId === teacher.IETechId;
      });

      const teacherFormGroup = this.fb.group({
        TeacherId: new FormControl(teacher.TechId),
        TeacherName: new FormControl(teacher.TeacherName),
        CollegeName: new FormControl(teacher.HomeCgName),
        DsName: new FormControl(teacher.DsName),
        Designation: new FormControl(teacher.Designation),
        Type: new FormControl(teacher.Type),
        AssignClg: new FormControl(teacher.AssignedCgName),
        AssignClgCode: new FormControl(teacher.AssignedCgCode),
        Availability: new FormControl(teacher.Availability),
        AcceptStatus: new FormControl(teacher.AcceptStatus),
        AssignFor: new FormControl(teacher.AssignedFor),
        ProvisionalId: new FormControl(teacher.ProvisionalId || null),
        FinalId: new FormControl(teacher.FinalId || null),
        IETechId: new FormControl(teacher.IETechId || null),
        MobileNo: new FormControl(teacher.MobileNo || null),
      });
      intExternalTeaArray.push(teacherFormGroup);
    });
  }

  loadFinalList() {
    this.spinner.show();
    const payload = {
      SessionId: this.teacherAssignForm.value.SessionId,
      SubId: this.teacherAssignForm.value.SubCode,
      ReqType: this.teacherAssignForm.value.ReqType,
      CoCode: this.teacherAssignForm.value.CoCode
    };

    this.umsService.getFinalAssTeachers(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.publishMessage = '';
          this.publishBtn = true;
          this.teachersList = res.data;
          this.filteredteachersList = this.teachersList.slice();
          this.rebuildIntExternalFormArray();
          this.updateAcceptAllButtonState();
          this.updateSendNotificationsButtonState();
        } else {
          this.publishBtn = false;
          this.publishMessage = res.message || 'Final examiner list not available.';
          this.PETeacher = false;
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.publishBtn = false;
        this.publishMessage = 'Error loading final list.';
        this.PETeacher = false;
      }
    });
  }

  getTeachersData() {
    // CollegeDistrict
    //this function call for mapping data get
    this.getExaminer()
    // this.teacherAssignForm.controls['CollegeDistrict'].setValue(item.DsName)
    if (this.teacherAssignForm.value.ReqType == 'PE') {

      this.PETeacher = true;
      this.COTeacher = false;
      this.CITeacher = false;
      this.INVTeacher = false;
      this.spinner.show();
      const payload = {};
      payload['SessionId'] = this.teacherAssignForm.value.SessionId;
      payload['SubId'] = this.teacherAssignForm.value.SubCode;
      payload['ReqType'] = this.teacherAssignForm.value.ReqType;
      this.umsService.getProvisionalAssTeachers(payload).subscribe(res => {
        if (res.status) {
          this.spinner.hide();
          this.PETeacher = true;
          this.publishMessage = '';
          this.publishBtn = true;
          this.teachersList = res.data;
          this.filteredteachersList = this.teachersList.slice();
          const intExternalTeaArray = this.teacherAssignForm.get('intExternalTeaArray') as FormArray;
          intExternalTeaArray.clear();
          this.savedTeachersData;
          this.teachersList.forEach(teacher => {
            const saved = this.savedTeachersData.find(t => {
              return t.InternalTechId === teacher.IETechId || t.ExternalTechId === teacher.IETechId;
            });
            // let UGExperience = teacher.UGExpYears + 'Y,' + teacher.UGExpMonths +'M,' + teacher.UGExpDays + 'D'
            //  let PGExperience = teacher.PGExpYears + 'Y,' + teacher.PGExpMonths +'M,' + teacher.PGExpDays + 'D'
            //  const isAvailable = (teacher.Availability).trim().toLowerCase() !== 'no';
            const derivedTechDesig = this.mapAssignedForToTechDesig(teacher.AssignedFor);
            if (saved) {
              const teacherFormGroup = this.fb.group({
                TeacherId: new FormControl(teacher.TechId),
                TeacherName: new FormControl(teacher.TeacherName),
                CollegeName: new FormControl(teacher.HomeCgName),
                DsName: new FormControl(teacher.DsName),
                Designation: new FormControl(teacher.Designation),
                Type: new FormControl(teacher.Type),
                // teachercheckbox: new FormControl(!!saved),  
                //  UGExperience: new FormControl(UGExperience),  
                //  PGExperience: new FormControl(PGExperience),  
                //  HOD: new FormControl(teacher.isHOD),  
                AssignClg: new FormControl(teacher.AssignedCgName),
                AssignClgCode: new FormControl(teacher.AssignedCgCode),
                Availability: new FormControl(teacher.Availability),
                AcceptStatus: new FormControl(teacher.AcceptStatus),
                AssignFor: new FormControl(teacher.AssignedFor),
                ProvisionalId: new FormControl(teacher.ProvisionalId || null),
                FinalId: new FormControl(teacher.FinalId || null),
                IETechId: new FormControl(teacher.IETechId || null),
                MobileNo: new FormControl(teacher.MobileNo || null),
                //  teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }), 
              });
              intExternalTeaArray.push(teacherFormGroup);

            } else {
              // If no match is found in savedTeachersData, still add the teacher with a default checkbox value (unchecked)
              const teacherFormGroup = this.fb.group({
                TeacherId: new FormControl(teacher.TechId),
                TeacherName: new FormControl(teacher.TeacherName),
                CollegeName: new FormControl(teacher.HomeCgName),
                DsName: new FormControl(teacher.DsName),
                Designation: new FormControl(teacher.Designation),
                Type: new FormControl(teacher.Type),
                //  UGExperience: new FormControl(UGExperience),  
                //  PGExperience: new FormControl(PGExperience),  
                //  HOD: new FormControl(teacher.isHOD),  
                AssignClg: new FormControl(teacher.AssignedCgName),
                AssignClgCode: new FormControl(teacher.AssignedCgCode),
                // teachercheckbox: new FormControl(false) ,
                Availability: new FormControl(teacher.Availability),
                AcceptStatus: new FormControl(teacher.AcceptStatus),
                AssignFor: new FormControl(teacher.AssignedFor),
                ProvisionalId: new FormControl(teacher.ProvisionalId || null),
                FinalId: new FormControl(teacher.FinalId || null),
                IETechId: new FormControl(teacher.IETechId || null),
                MobileNo: new FormControl(teacher.MobileNo || null),
                //  teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),  
              });

              // Push the teacher to the respective array based on their Type
              intExternalTeaArray.push(teacherFormGroup);
            }
          });
          this.updateAcceptAllButtonState();
          this.updateSendNotificationsButtonState();
          if (this.allProvisionalAccepted) {
            this.isFinalListMode = true;
            this.loadFinalList();
          }
        }
        else {
          this.publishBtn = false;
          this.publishMessage = 'Provisional examiner list generation is pending.';
          this.PETeacher = false;
        }
      });
    }
    else if (this.teacherAssignForm.value.ReqType == 'CO') {
      this.PETeacher = false;
      this.COTeacher = true;
      this.CITeacher = false;
      this.INVTeacher = false;
      const payload = {};
      payload['CgCode'] = this.teacherAssignForm.value.CgCode;
      payload['SubCode'] = this.teacherAssignForm.value.SubCode;
      payload['ReqType'] = this.teacherAssignForm.value.ReqType;
      this.umsService.getSubTeachers(payload).subscribe(res => {
        this.spinner.hide()
        this.teachersList = res.data;
        this.filteredteachersList = this.teachersList.slice();
        const COTeachersArray = this.teacherAssignForm.get('COTeachersArray') as FormArray;
        COTeachersArray.clear();

        this.savedTeachersData;
        this.teachersList.forEach(teacher => {
          const saved = this.savedTeachersData.find(t => {
            return t.InternalTechId === teacher.TeacherId || t.ExternalTechId === teacher.TeacherId;
          });
          let UGExperience = teacher.UGExpYears + 'Y,' + teacher.UGExpMonths + 'M,' + teacher.UGExpDays + 'D'
          let PGExperience = teacher.PGExpYears + 'Y,' + teacher.PGExpMonths + 'M,' + teacher.PGExpDays + 'D'

          const isAvailable = (teacher.Availability || '').trim().toLowerCase() !== 'no';
          if (saved) {
            const teacherFormGroup = this.fb.group({
              TeacherId: new FormControl(teacher.TeacherId),
              TechDesig: new FormControl(teacher.TechDesig),
              TeacherName: new FormControl(teacher.TeacherName),
              CollegeName: new FormControl(teacher.CollegeName),
              DsName: new FormControl(teacher.DsName),
              Designation: new FormControl(teacher.Designation),
              Type: new FormControl(teacher.Type),
              UGExperience: new FormControl(UGExperience),
              PGExperience: new FormControl(PGExperience),
              HOD: new FormControl(teacher.isHOD),
              AssignClg: new FormControl(teacher.DestinationCollegeName),
              Availability: new FormControl(teacher.Availability),
              teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),
              //Reason: new FormControl(teacher.Reason),
            });

            COTeachersArray.push(teacherFormGroup);

          } else {
            // If no match is found in savedTeachersData, still add the teacher with a default checkbox value (unchecked)
            const teacherFormGroup = this.fb.group({
              TeacherId: new FormControl(teacher.TeacherId),
              TechDesig: new FormControl(teacher.TechDesig),
              TeacherName: new FormControl(teacher.TeacherName),
              CollegeName: new FormControl(teacher.CollegeName),
              DsName: new FormControl(teacher.DsName),
              Designation: new FormControl(teacher.Designation),
              Type: new FormControl(teacher.Type),
              UGExperience: new FormControl(UGExperience),
              PGExperience: new FormControl(PGExperience),
              HOD: new FormControl(teacher.isHOD),
              AssignClg: new FormControl(teacher.DestinationCollegeName),
              Availability: new FormControl(teacher.Availability),
              teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),
              // Reason: new FormControl(teacher.Reason),
            });

            COTeachersArray.push(teacherFormGroup);
          }
        });


      });
    }
    else if (this.teacherAssignForm.value.ReqType == 'CI') {
      this.PETeacher = false;
      this.COTeacher = false;
      this.CITeacher = true;
      this.INVTeacher = false;
      const payload = {};
      payload['CgCode'] = this.teacherAssignForm.value.CgCode;
      payload['SubCode'] = this.teacherAssignForm.value.SubCode;
      payload['ReqType'] = this.teacherAssignForm.value.ReqType;
      this.umsService.getSubTeachers(payload).subscribe(res => {
        this.spinner.hide()
        this.teachersList = res.data;
        this.filteredteachersList = this.teachersList.slice();
        const CITeachersArray = this.teacherAssignForm.get('CITeachersArray') as FormArray;
        //  const externalTeachersArray = this.teacherAssignForm.get('externalTeachersArray') as FormArray;

        CITeachersArray.clear();
        //  externalTeachersArray.clear();
        this.savedTeachersData;
        this.teachersList.forEach(teacher => {
          const saved = this.savedTeachersData.find(t => {
            return t.InternalTechId === teacher.TeacherId || t.ExternalTechId === teacher.TeacherId;
          });
          let UGExperience = teacher.UGExpYears + 'Y,' + teacher.UGExpMonths + 'M,' + teacher.UGExpDays + 'D'
          let PGExperience = teacher.PGExpYears + 'Y,' + teacher.PGExpMonths + 'M,' + teacher.PGExpDays + 'D'

          const isAvailable = (teacher.Availability || '').trim().toLowerCase() !== 'no';
          if (saved) {
            const teacherFormGroup = this.fb.group({
              TeacherId: new FormControl(teacher.TeacherId),
              TeacherName: new FormControl(teacher.TeacherName),
              TechDesig: new FormControl(teacher.TechDesig),
              CollegeName: new FormControl(teacher.CollegeName),
              DsName: new FormControl(teacher.DsName),
              Designation: new FormControl(teacher.Designation),
              Type: new FormControl(teacher.Type),
              // teachercheckbox: new FormControl(!!saved),  
              UGExperience: new FormControl(UGExperience),
              PGExperience: new FormControl(PGExperience),
              HOD: new FormControl(teacher.isHOD),
              AssignClg: new FormControl(teacher.DestinationCollegeName),
              Availability: new FormControl(teacher.Availability),
              teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),
              //Reason: new FormControl(teacher.Reason),
            });

            CITeachersArray.push(teacherFormGroup);

          } else {
            // If no match is found in savedTeachersData, still add the teacher with a default checkbox value (unchecked)
            const teacherFormGroup = this.fb.group({
              TeacherId: new FormControl(teacher.TeacherId),
              TeacherName: new FormControl(teacher.TeacherName),
              TechDesig: new FormControl(teacher.TechDesig),
              CollegeName: new FormControl(teacher.CollegeName),
              DsName: new FormControl(teacher.DsName),
              Designation: new FormControl(teacher.Designation),
              Type: new FormControl(teacher.Type),
              UGExperience: new FormControl(UGExperience),
              PGExperience: new FormControl(PGExperience),
              HOD: new FormControl(teacher.isHOD),
              AssignClg: new FormControl(teacher.DestinationCollegeName),
              // teachercheckbox: new FormControl(false) ,
              Availability: new FormControl(teacher.Availability),
              teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),
              //Reason: new FormControl(teacher.Reason),
            });

            CITeachersArray.push(teacherFormGroup);
          }
        });


      });
    }
    else {
      this.PETeacher = false;
      this.COTeacher = false;
      this.CITeacher = false;
      this.INVTeacher = true;
      const payload = {};
      payload['CgCode'] = this.teacherAssignForm.value.CgCode;
      payload['SubCode'] = this.teacherAssignForm.value.SubCode;
      payload['ReqType'] = this.teacherAssignForm.value.ReqType;
      this.umsService.getSubTeachers(payload).subscribe(res => {
        this.spinner.hide()
        this.teachersList = res.data;
        this.filteredteachersList = this.teachersList.slice();
        const INVTeachersArray = this.teacherAssignForm.get('INVTeachersArray') as FormArray;
        //  const externalTeachersArray = this.teacherAssignForm.get('externalTeachersArray') as FormArray;

        INVTeachersArray.clear();
        //  externalTeachersArray.clear();
        this.savedTeachersData;
        this.teachersList.forEach(teacher => {
          const saved = this.savedTeachersData.find(t => {
            return t.InternalTechId === teacher.TeacherId || t.ExternalTechId === teacher.TeacherId;
          });
          let UGExperience = teacher.UGExpYears + 'Y,' + teacher.UGExpMonths + 'M,' + teacher.UGExpDays + 'D'
          let PGExperience = teacher.PGExpYears + 'Y,' + teacher.PGExpMonths + 'M,' + teacher.PGExpDays + 'D'

          const isAvailable = (teacher.Availability || '').trim().toLowerCase() !== 'no';
          if (saved) {
            const teacherFormGroup = this.fb.group({
              TeacherId: new FormControl(teacher.TeacherId),
              TeacherName: new FormControl(teacher.TeacherName),
              TechDesig: new FormControl(teacher.TechDesig),
              CollegeName: new FormControl(teacher.CollegeName),
              DsName: new FormControl(teacher.DsName),
              Designation: new FormControl(teacher.Designation),
              Type: new FormControl(teacher.Type),
              // teachercheckbox: new FormControl(!!saved),  
              UGExperience: new FormControl(UGExperience),
              PGExperience: new FormControl(PGExperience),
              HOD: new FormControl(teacher.isHOD),
              AssignClg: new FormControl(teacher.DestinationCollegeName),
              Availability: new FormControl(teacher.Availability),
              teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),
              //Reason: new FormControl(teacher.Reason),
            });

            INVTeachersArray.push(teacherFormGroup);

          } else {
            // If no match is found in savedTeachersData, still add the teacher with a default checkbox value (unchecked)
            const teacherFormGroup = this.fb.group({
              TeacherId: new FormControl(teacher.TeacherId),
              TeacherName: new FormControl(teacher.TeacherName),
              TechDesig: new FormControl(teacher.TechDesig),
              CollegeName: new FormControl(teacher.CollegeName),
              DsName: new FormControl(teacher.DsName),
              Designation: new FormControl(teacher.Designation),
              Type: new FormControl(teacher.Type),
              UGExperience: new FormControl(UGExperience),
              PGExperience: new FormControl(PGExperience),
              HOD: new FormControl(teacher.isHOD),
              AssignClg: new FormControl(teacher.DestinationCollegeName),
              // teachercheckbox: new FormControl(false) ,
              Availability: new FormControl(teacher.Availability),
              teachercheckbox: new FormControl({ value: !!saved, disabled: !isAvailable }),
              //Reason: new FormControl(teacher.Reason),
            });

            INVTeachersArray.push(teacherFormGroup);
          }
        });


      });
    }
  }

  getControlsInt() {
    return (this.teacherAssignForm.get('internalTeachersArray') as FormArray).controls;
  }
  getControlsIntExternal() {
    return (this.teacherAssignForm.get('intExternalTeaArray') as FormArray).controls;
  }

  getControlsExt() {
    return (this.teacherAssignForm.get('externalTeachersArray') as FormArray).controls;
  }

  getControlsCOTeacher() {
    return (this.teacherAssignForm.get('COTeachersArray') as FormArray).controls;
  }
  getControlsCITeachers() {
    return (this.teacherAssignForm.get('CITeachersArray') as FormArray).controls;
  }
  getControlsINVTeachers() {
    return (this.teacherAssignForm.get('INVTeachersArray') as FormArray).controls;
  }


  save() {
    if (!this.validateSelection()) {
      return;
    }
    else {
      this.deletedata();

    }
  }


  onCheckboxChangeInt(index: number) {
    const controls = this.teacherAssignForm.get('internalTeachersArray')['controls'];
    const isChecked = controls[index].get('teachercheckbox').value;

    // Update the selected count based on current selections
    this.selectedCount = controls.filter(c => c.get('teachercheckbox').value).length;

    // // Allow checking if the selected count is less than the maximum allowed
    // if (!isChecked && this.selectedCount < this.InterTeachCnt) {
    //   controls[index].get('teachercheckbox').patchValue(true, { emitEvent: false });
    // } 
    // // Allow unchecking only if the selected count is greater than the minimum allowed
    // else if (isChecked && this.selectedCount > this.InterTeachCnt) {
    //   controls[index].get('teachercheckbox').patchValue(false, { emitEvent: false });
    // }
  }

  onCheckboxChangeExt(index: number) {
    const controls = this.teacherAssignForm.get('externalTeachersArray')['controls'];
    const selectedCount = controls.filter(c => c.get('teachercheckbox').value).length;

    const isChecked = controls[index].get('teachercheckbox').value;

    // If the checkbox is checked and we haven't reached the max count yet
    // if (!isChecked && selectedCount < this.ExterTeachCnt) {
    //   controls[index].get('teachercheckbox').patchValue(true, { emitEvent: false });
    // } 
    // // If it's unchecked, we allow it as long as the count doesn't drop below the required minimum
    // else if (isChecked && selectedCount > this.ExterTeachCnt) {
    //   controls[index].get('teachercheckbox').patchValue(false, { emitEvent: false });
    // }
  }

  validateSelection(): boolean {
    let isValid = true;
    this.internalError = '';
    this.externalError = '';

    // Get the selected count for both internal and external
    this.internalSelected = this.teacherAssignForm.get('internalTeachersArray')['controls']
      .filter(c => c.get('teachercheckbox').value).length;

    this.externalSelected = this.teacherAssignForm.get('externalTeachersArray')['controls']
      .filter(c => c.get('teachercheckbox').value).length;

    // Check if the number of selected internal teachers matches the required count
    if (this.internalSelected != this.InterTeachCnt) {
      this.internalError = `Please select exactly ${this.InterTeachCnt} Chairperman/Convener.`;
      isValid = false;
    }

    // Check if the number of selected external teachers matches the required count
    if (this.externalSelected != this.ExterTeachCnt) {
      this.externalError = `Please select exactly ${this.ExterTeachCnt} External Examiner(s).`;
      isValid = false;
    }

    return isValid;
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide();
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  getExaminer() {
    this.spinner.show();
    let payload = {};
    // payload['CgCode'] = this.teacherAssignForm.value.CgCode;
    payload['SubCode'] = this.teacherAssignForm.value.SubCode;
    payload['CoCode'] = this.teacherAssignForm.value.CoCode;
    payload['SessionId'] = this.teacherAssignForm.value.SessionId;
    this.umsService.getExaminer(payload).subscribe(res => {
      this.savedTeachersData = res.data;
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    });
  }


  deletedata() {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {

        SessionId: this.teacherAssignForm.value.SessionId,
        SubId: this.teacherAssignForm.value.SubCode,
        CoCode: this.teacherAssignForm.value.CoCode,
        CgCode: this.teacherAssignForm.value.CgCode,
        EmId: this.ExamId,
      },
    };
    this.httpClient.delete(this.APIService + '/supervisor/InternalExternalTeacher', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        // let data = {}
        // data['message'] = cc[0].message
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.submitExaminer();
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.ngOnInit();
      });

  }

  submitExaminer() {
    let payload = this.teacherAssignForm.value;
    let internalTeachersArray = this.teacherAssignForm.get('internalTeachersArray') as FormArray;
    let externalTeachersArray = this.teacherAssignForm.get('externalTeachersArray') as FormArray;
    const combinedArray = [...internalTeachersArray.value, ...externalTeachersArray.value];
    let teacherArray = combinedArray.filter(item => item.teachercheckbox === true)
    const finalPayload = [];
    teacherArray.forEach(item => {
      const examiner = {
        SessionId: payload.SessionId,
        SubId: payload.SubCode,
        CoCode: payload.CoCode,
        CgCode: payload.CgCode,
        EmId: this.ExamId,
        Notes: payload.Notes,
        ExternalTechId: item.Type === 'External' ? item.TeacherId : '',
        InternalTechId: item.Type === 'Internal' ? item.TeacherId : '',
        IsPractical: item.teachercheckbox
      };

      finalPayload.push(examiner);
    })
    finalPayload.forEach(teacherPayload => {
      this.umsService.saveExaminer(teacherPayload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let data = {}
          data['message'] = 'Submitted Successfully'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      });
    });

  }


  Publish() {

    if (!this.teacherAssignForm.value.SubCode ||
      !this.teacherAssignForm.value.CoCode ||
      !this.teacherAssignForm.value.SessionId) {

      let data = {};
      data['message'] = "Please select Course, Subject and Session before publishing.";
      data['title'] = 'Warning';
      data['icon'] = 'fas fa-exclamation-triangle';

      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    if (!this.publishBtn) {
      let data = {};
      data['message'] = this.publishMessage || "Provisional examiner list is not ready.";
      data['title'] = 'Warning';
      data['icon'] = 'fas fa-exclamation-triangle';

      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    if (!this.savedTeachersData || this.savedTeachersData.length === 0) {
      let data = {};
      data['message'] = "Please assign teachers before publishing.";
      data['title'] = 'Warning';
      data['icon'] = 'fas fa-exclamation-triangle';

      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    let payload = {};
    payload['SubId'] = this.teacherAssignForm.value.SubCode;
    payload['CoCode'] = this.teacherAssignForm.value.CoCode;
    payload['SessionId'] = this.teacherAssignForm.value.SessionId;
    payload['PublishStatus'] = 1;
    this.spinner.show();
    this.umsService.publishAssTeachers(payload).subscribe(res => {
      this.spinner.hide();

      if (res.status) {
        this.publishDone = true;
        this.updateAcceptAllButtonState();
        this.updateSendNotificationsButtonState();
        let data = {};
        data['message'] = "Assignment notification sent successfully to all examiners.";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';

        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }

    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  ReAssign(subject) {
    this.spinner.show()
    const payload = {};
    payload['SubId'] = this.teacherAssignForm.value.SubCode;
    payload['TeacherId'] = subject.value.TeacherId;
    payload['AcceptStatus'] = 0;
    let techDesig = subject.value.TechDesig;
    if (!techDesig && subject.value.AssignFor) {
      console.log('TechDesig was null, deriving from AssignFor:', subject.value.AssignFor);
      const assignFor = subject.value.AssignFor;
      const lower = assignFor.toLowerCase().trim();
      if (lower.includes('chairman') || lower.includes('convener')) techDesig = 'CP';
      else if (lower === 'internal' || lower.includes('internal examiner')) techDesig = 'INT';
      else if (lower === 'external' || lower.includes('external examiner')) techDesig = 'EXT';
    }
    payload['TechDesig'] = techDesig;

    console.log('ReAssign payload:', payload);

    this.umsService.generateRandomAssiTea(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Re-Assigned Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
          this.ngOnInit();
        });
      } else {
        this.spinner.hide();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();

      })
  }

  ReProvisional(subject) {
    const dialogRef = this.dialog.open(ReProvisionalComponent, {
      width: 'auto',
      data: { key: "New", selected: subject },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  acceptAllExaminers() {
    const subCode = this.teacherAssignForm.value.SubCode;
    const sessionId = this.teacherAssignForm.value.SessionId;
    const coCode = this.teacherAssignForm.value.CoCode;
    const cgCode = this.teacherAssignForm.value.CgCode;


    if (!subCode || !sessionId || !coCode) {
      this.showAlert('Please select Course, Subject and Session.', 'Warning', 'fas fa-exclamation-triangle');
      return;
    }


    const confirmData = {
      message: 'Are you sure you want to accept ALL provisional examiners?',
      title: 'Confirm',
      icon: 'fas fa-question-circle'
    };
    const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      confirmData
    );
    confirmDialog.afterClosed().subscribe(result => {
      console.log('Dialog result:', result);
      if (result === 'yes') {
        this.proceedAcceptAll(subCode, sessionId, coCode, cgCode);
      } else {
        this.showAlert('Processing cancelled.', 'Information', 'fas fa-close');
      }
    });
  }

  private proceedAcceptAll(subCode: any, sessionId: any, coCode: any, cgCode: any) {
    console.log(' proceedAcceptAll called with:', { subCode, sessionId, coCode });
    this.spinner.show();

    const payload = {
      SubId: subCode,
      SessionId: sessionId,
      CoCode: coCode,
    };

    this.umsService.acceptAllExaminers(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.showAlert(res.message || 'All provisional examiners accepted.', 'Success', 'fas fa-check');
          // NEW: After accept all, automatically switch to final list mode and load final list
          this.isFinalListMode = true;
          this.getTeachersData();   // this will now call loadFinalList()
        } else {
          this.showAlert(res.message || 'Failed to accept examiners.', 'Error', 'fas fa-times');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        console.error('API Error:', error);
        this.showAlert(error.error?.message || 'Server error.', 'Error', 'fas fa-exclamation-triangle');
      }
    });
  }

  private showAlert(message: string, title: string, icon: string) {
    const data = { message, title, icon };
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  openManualReassign(subject: any) {
    const ieTechId = subject.get('IETechId')?.value;
    const sessionId = this.teacherAssignForm.value.SessionId;

    if (!sessionId) {
      this.showAlert('Please select a Session first.', 'Warning', 'fas fa-exclamation-triangle');
      return;
    }

    if (!ieTechId) {
      this.showAlert('IETechId not found for this examiner.', 'Error', 'fas fa-exclamation-triangle');
      return;
    }

    this.spinner.show();
    const payload = { IETechId: ieTechId, SessionId: sessionId };

    this.umsService.getprovisionalReplacementCandidates(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status && res.data && res.data.length > 0) {
          const dialogRef = this.dialog.open(ReassignTeachersComponent, {
            width: '900px',
            disableClose: true,
            data: {
              iETechId: ieTechId,
              sessionId: sessionId,
              candidates: res.data,
              currentSlot: res.data[0]
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result && result.refresh) {
              this.getTeachersData();
            }
          });
        } else {
          this.showAlert(res.message || 'No eligible replacement teachers found.', 'Info', 'fas fa-info-circle');
        }
      },
      error: (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.showAlert(err.error?.message || 'Failed to fetch replacement candidates.', 'Error', 'fas fa-times');
      }
    });
  }

  openReassignFinal(subject: any) {
    const FinalId = subject.get('FinalId')?.value;
    const sessionId = this.teacherAssignForm.value.SessionId;

    if (!sessionId) {
      this.showAlert(
        'Please select a Session first.',
        'Warning',
        'fas fa-exclamation-triangle'
      );
      return;
    }

    if (!FinalId) {
      this.showAlert(
        'FinalId not found for this examiner.',
        'Error',
        'fas fa-exclamation-triangle'
      );
      return;
    }

    this.spinner.show();

    // FinalId value passed as IETechId
    const payload = {
      IETechId: FinalId,
      SessionId: sessionId
    };

    this.umsService.getFinalReplacementCandidates(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.status && res.data && res.data.length > 0) {

          const dialogRef = this.dialog.open(ReassignFinalComponent, {
            width: '900px',
            disableClose: true,
            data: {
              iETechId: FinalId,
              sessionId: sessionId,
              candidates: res.data,
              currentSlot: res.data[0]
            }
          });

          dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.refresh) {
              this.getTeachersData();
            }
          });

        } else {
          this.showAlert(
            res.message || 'No eligible replacement teachers found.',
            'Info',
            'fas fa-info-circle'
          );
        }
      },

      error: (err: HttpErrorResponse) => {
        this.spinner.hide();

        this.showAlert(
          err.error?.message || 'Failed to fetch replacement candidates.',
          'Error',
          'fas fa-times'
        );
      }
    });
  }

  updateAcceptAllButtonState(): void {
    const intExternalArray = this.teacherAssignForm.get('intExternalTeaArray') as FormArray;
    if (!intExternalArray || intExternalArray.length === 0) {
      this.disableAcceptAll = false;
      return;
    }

    const allAccepted = intExternalArray.controls.every(control =>
      control.get('AcceptStatus')?.value === 1
    );
    // Disable if all accepted OR publish not yet done
    this.disableAcceptAll = allAccepted || !this.publishDone;
  }

  updateSendNotificationsButtonState(): void {
    const intExternalArray = this.teacherAssignForm.get('intExternalTeaArray') as FormArray;
    if (!intExternalArray || intExternalArray.length === 0) {
      this.disableSendNotifications = false;
      return;
    }

    // Check if any examiner has Availability = -1
    const hasAvailabilityMinusOne = intExternalArray.controls.some(control =>
      control.get('Availability')?.value === -1
    );

    // Disable Send Notifications button if any Availability is -1
    this.disableSendNotifications = hasAvailabilityMinusOne;
  }

  get allProvisionalAccepted(): boolean {
    const intExternalArray = this.teacherAssignForm.get('intExternalTeaArray') as FormArray;
    if (!intExternalArray || intExternalArray.length === 0) return false;
    return intExternalArray.controls.every(control => {
      const status = control.get('AcceptStatus')?.value;
      return status == 1 || status === '1';   // accept both number and string
    });
  }
  sendEmail() {
    const dialogRef = this.dialog.open(SendEmailDialogComponent, {
      width: '1100px',
      disableClose: true,
      data: {
        CoCode: this.teacherAssignForm.value.CoCode,
        SubId: this.teacherAssignForm.value.SubCode,
        SessionId: this.teacherAssignForm.value.SessionId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.sent) {
        this.showAlert(`Email sent to ${result.count} examiner(s).`, 'Information', 'fas fa-check');
      }
    });
  }
}